import DetailApi from '@/api/detail'

const initialState = () => ({
  item: null
})

export const Detail = {
  namespaced: true,
  state: initialState,
  getters: {
    item: state => state.item
  },
  mutations: {
    RESET_STATE (state) {
      const initial = initialState()
      Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
    SET_ITEM (state, item) {
      state.item = item
    }
  },
  actions: {
    getItem: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        DetailApi.getItem(payload)
          .then((response) => {
            if (response && response.title && response.message) {
              reject(response)
            } else {
              commit('SET_ITEM', response.data && response.data.data)
              resolve()
            }
          })
      })
    }
  }
}
